import type {
  KeyData,
  SeriesData,
  SeriesMetadata,
  SeriesRecord
} from '@/components/Chart/types/chartData';
import { aggregateTimeSeriesPoints } from '@/components/Chart/utils/aggregateTimeSeriesPoints';
import type { TimeSeriesPoint } from '@/components/Chart/utils/buildChartLineSeries';
import { buildChartLineSeries } from '@/components/Chart/utils/buildChartLineSeries';
import { getFieldDecimalPlaces } from '@/components/Chart/utils/getFieldDecimalPlaces';
import { getSeriesId } from '@/components/Chart/utils/getSeriesId';
import { getSeriesName } from '@/components/Chart/utils/getSeriesName';

type ParseableElements = {
  symbolIndex: number;
  shortTitle: string | undefined;
  key: KeyData;
  metadata: SeriesMetadata;
  transactionDate: string | undefined;
  color?: string;
};
export const parseDataToChartSeries = (
  series: SeriesData,
  parseableElements: ParseableElements,
  isDhChartFullscreen: boolean,
  seriesDataAggregator: (tsData: SeriesRecord, decimalPlaces: number) => TimeSeriesPoint
) => {
  const { symbolIndex, shortTitle, key, metadata, transactionDate, color } = parseableElements;
  return Object.keys(series).map((field: string, fieldIndex) => {
    const combinedIndex = symbolIndex * Object.keys(series).length + fieldIndex;
    const fieldValue = series?.[field];
    const decimalPlaces = getFieldDecimalPlaces(fieldValue);

    const name = isDhChartFullscreen
      ? metadata.Alias || key.Code
      : getSeriesName(shortTitle, metadata.Title, transactionDate);
    const id = getSeriesId(key, field, transactionDate);
    const timeSeriesPoints = aggregateTimeSeriesPoints(
      series,
      field,
      decimalPlaces,
      seriesDataAggregator
    );
    return buildChartLineSeries({
      id,
      name,
      color,
      timeSeriesPoints,
      context: {
        ...key,
        ...metadata,
        decimalPlaces,
        combinedIndex,
        transactionDate,
        field,
        color
      },
      isDaily: 'Prompt' === key.PeriodType
    });
  });
};
